module.exports = __webpack_public_path__ + "static/media/website-design.baa3283d.png";